import React from "react";
import Heading from "./small-component/Heading";
// import SwiperCore, { Autoplay, Pagination } from "swiper";

// import { SwiperSlide, Swiper } from "swiper/react";

// import userimg1 from "../assets/img/testimonalimg/1.svg";
// import userimg2 from "../assets/img/testimonalimg/6.svg";
// import userimg3 from "../assets/img/testimonalimg/7.svg";
import FormSection from "./form";

// const testimonialInfo = [
//   {
//     name: "Sonu Mahto",
//     position: "Founder & CEO",
//     imgUrl: userimg1,
//     testimonial:
//       "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibhet. Maecen aliquam, risus at semper.",
//   },
//   {
//     name: "Swaraj Kumar",
//     position: "MD & Head of Strategy & Board Member",
//     imgUrl: userimg2,
//     testimonial:
//       "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibhet. Maecen aliquam, risus at semper.",
//   },
//   {
//     name: "Shivam Sharma",
//     position: "Head of Clients Management & Social Marketing",
//     imgUrl: userimg3,
//     testimonial:
//       "Proin iaculis purus consequat sem cure digni ssim donec porttitora entum suscipit rhoncus. Accusantium quam, ultricies eget id, aliquam eget nibhet. Maecen aliquam, risus at semper.",
//   },
// ];

// const TestimonialCard = (props) => {
//   return (
//     <div className="testimonial-item">
//       <img className="testimonial-img" src={props.imgUrl} alt="profile" />
//       <h3>{props.name}</h3>
//       <h4>{props.position}</h4>
//     </div>
//   );
// };

// export  function MutipleSlidesPerView() {
//   SwiperCore.use([Autoplay, Pagination]);
//   return (
//     <div>
//       <Swiper
//         spaceBetween={50}
//         slidesPerView={3}
//         loop={true}
//         autoplay={{ delay: 2500 }}
//         pagination={{ clickable: true, type: "bullets" }}
//         breakpoints={{
//           // when window width is >= 220px
//           220: {
//             slidesPerView: 1,
//             spaceBetween: 20,
//           },
//           // when window width is >= 580px
//           580: {
//             slidesPerView: 2,
//             spaceBetween: 30,
//           },
//           // when window width is >= 840px
//           840: {
//             slidesPerView: 3,
//             spaceBetween: 40,
//           },
//         }}
//       >
//         {testimonialInfo.map((info) => {
//           return (
//             <SwiperSlide key={info.name}>
//               <TestimonialCard
//                 name={info.name}
//                 imgUrl={info.imgUrl}
//                 position={info.position}
//                 testimonial={info.testimonial}
//               />
//             </SwiperSlide>
//           );
//         })}
//       </Swiper>
//     </div>
//   );
// }

export default function Testimonial() {
  return (
    <section id="testimonial" className="section-bg">
      <div className="container">
        <Heading title="Get In Touch" />


        <FormSection/>

        {/* <div className="container">
          <MutipleSlidesPerView />
        </div> */}
      </div>
    </section>
  );
}
